import React from "react";
import { ModalBuilder, Modal, Table } from "@redriver/cinnamon";
import { PermissionCheck } from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { getReturnOnInvestmentForEdit } from "./actions";
import ReturnOnInvestmentForm from "./ReturnOnInvestmentForm";

const EditReturnOnInvestmentModal = ({
  submitAction,
  onSubmitted,
  returnOnInvestmentId,
  dealerOfficeId,
}) => (
  <PermissionCheck target={Targets.ReturnOnInvestment} action={Actions.Edit}>
    <ModalBuilder
      withForm
      loadAction={getReturnOnInvestmentForEdit}
      loadParams={{ id: returnOnInvestmentId }}
      submitAction={submitAction}
      submitParams={{ id: returnOnInvestmentId }}
      onSubmitted={onSubmitted}
      renderTrigger={(showModal) => (
        <Table.MenuItem onClick={showModal}>Edit</Table.MenuItem>
      )}
      renderModal={(modalProps, formProps) => (
        <Modal.Edit {...modalProps} header="Edit ROI" submitLabel="Update">
          <ReturnOnInvestmentForm
            formProps={formProps}
            dealerOfficeId={dealerOfficeId}
          />
        </Modal.Edit>
      )}
    />
  </PermissionCheck>
);

export default EditReturnOnInvestmentModal;
